import IFiltro, { Grupo } from "@/interfaces/IFiltro";
import INormativo from "@/interfaces/INormativo";
import { ref } from "vue";



type Refinadores = {
  refinadorTipo: () => any[]
  refinadorSituacao: () => any[]
  refinadorData: () => any[]
  refinadorAno: () => any[]
  loadRefinadores: (normativos: INormativo[]) => Promise<any>
  loadRefinadoresAux: (normativos: INormativo[]) => Promise<any>
}
export default (): Refinadores => {
  const refinadores: any = ref(Set);
  const refinadoresAux: any = ref(Set);
  refinadores.value = [...new Set()];
  refinadoresAux.value = [...new Set()];

  const loadRefinadores = (normativos: INormativo[]) => {
    return new Promise((resolve) => {
      refinadores.value = [...new Set()];
      if (normativos && refinadores) {          
        normativos.forEach(({ codigoNorma, dscSituacao, dataDocumento }) => {
          addRefinador(refinadores.value, Grupo.TIPO, codigoNorma);
          addRefinador(refinadores.value, Grupo.SITUACAO, dscSituacao);
          const data = dataDocumento.split("/");          
          addRefinador(refinadores.value, Grupo.ANO, data[0]);
        });
      }      
      resolve({ refinadores: refinadores.value });
    });

  };
  const loadRefinadoresAux = (normativos: INormativo[]) => {
    return new Promise((resolve) => {
      refinadoresAux.value = [...new Set()];
      if (normativos && refinadoresAux) {
        normativos.forEach(({ codigoNorma, dscSituacao, dataDocumento }) => {
          addRefinador2(refinadoresAux.value, Grupo.TIPO, codigoNorma);
          addRefinador2(refinadoresAux.value, Grupo.SITUACAO, dscSituacao);
          const data = dataDocumento.split("/");
          addRefinador2(refinadoresAux.value, Grupo.ANO, data[0]);
        });
      }else{
        refinadoresAux.value = [...new Set()];        
      }
      resolve({ refinadores: refinadoresAux.value });
    });

  };
  const addRefinador = (refinadorList: IFiltro[], grupo: Grupo, valor: string) => {
    const found: IFiltro[] = refinadorList.filter((refinador) => refinador.item.name === valor); 
    const foundAux: IFiltro[] = refinadoresAux.value.filter((element:IFiltro) => element.item.name === valor);
    
    if(found.length==0 && foundAux.length>0){      
      refinadorList.push(foundAux[0]);    
    }else if(found.length>0 && foundAux.length>0){      
      found[0].props.quantidade = foundAux[0].props.quantidade;
    }else if (found.length == 0 && foundAux.length==0) {      
      const filtro: IFiltro | undefined =
      {
        item: {
          grupo: grupo,
          valor: valor,
          name: valor.trim(),
        },
        props:{quantidade: 0}
      }
      refinadorList.push(filtro);
    }else if (found.length > 0 && foundAux.length==0) {      
      found[0].props.quantidade = 0;
    } 
  };
  const addRefinador2 = (refinadorList: IFiltro[], grupo: Grupo, valor: string) => {
    const found: IFiltro[] = refinadorList.filter((refinador) => refinador.item.name === valor);
    if (found.length == 0) {
      const filtro: IFiltro | undefined =
      {
        item: {
          grupo: grupo,
          valor: valor,
          name: valor.trim(),
        },
        props:{quantidade: 1}
      }
      refinadorList.push(filtro);
    } else {
      const filtroAtual: IFiltro = found[0];
      filtroAtual.props.quantidade = filtroAtual.props.quantidade + 1;
    }
  };
  const refinadorTipo = (): IFiltro[] => {
    const filter = refinadores.value.filter((entry: IFiltro) => {
      return entry.item.grupo === Grupo.TIPO;
    });
    if (filter) {
      return filter.sort((n1: IFiltro, n2: IFiltro) => {
        return n1.item.valor.trim() > n2.item.valor.trim() ? 1 : -1
      });
    }
    return filter;
  };
  const refinadorSituacao = (): IFiltro[] => {
    const filter = refinadores.value.filter((entry: IFiltro) => {
      return entry.item.grupo === Grupo.SITUACAO;
    });
    if (filter) {
      return filter.sort((n1: IFiltro, n2: IFiltro) => {
        return n1.item.valor.trim() > n2.item.valor.trim() ? 1 : -1
      });
    }
    return filter;
  };
  const refinadorData = (): IFiltro[] => {
    const filter = refinadores.value.filter((entry: IFiltro) => {
      return entry.item.grupo === Grupo.DATA;
    });
    if (filter) {
      return filter.sort((n1: IFiltro, n2: IFiltro) => {
        return n1.item.valor.trim() > n2.item.valor.trim() ? 1 : -1
      });
    }
    return filter;
  };
  const refinadorAno = (): IFiltro[] => {
    const filter = refinadores.value.filter((entry: IFiltro) => {
      return entry.item.grupo === Grupo.ANO;
    });

    if (filter) {
      return filter.sort((n1: IFiltro, n2: IFiltro) => {
        return n1.item.valor.trim() > n2.item.valor.trim() ? -1 : 1
      });
    }
    return filter;
  }

  return {
    refinadorTipo,
    refinadorSituacao,
    refinadorData,
    refinadorAno,
    loadRefinadores,
    loadRefinadoresAux
  }

}
